import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import axios from 'axios'

import Teig from './Teig.jsx'
import TeigIcon from '../../../images/Teig.png'
import CollapseIcon from '../../../images/expand copy 3.png'
import ExpandIcon from '../../../images/collapse copy 3.png'

class TeigList extends Component {
    state = {
        teiger: [],
        isLoading: false,
        isOpened: false,
        continuationToken: null        
    }

    getTeiger = () => {
        this.setState({isLoading: true})
        axios.get(`${this.props.settings.baseUrl}api/matrikkelenhet/${this.props.matrikkelenhetId}/teig`, {
            params: {
                token: this.props.token,
                size: 50,
                continuationToken: this.state.continuationToken
            }
        })
        .then(({data}) => {
            this.setState({
                teiger: [...this.state.teiger, ...data.teiger],
                isLoading: false,
                continuationToken: data.nextContinuationToken
            })
        })
      }

      toggleTeiger = () => {
        if (this.props.antall == 0) return
                  
        if (this.state.teiger.length == 0) {
            this.getTeiger()
        }

        this.setState({isOpened: !this.state.isOpened})
    }

    render() {
        const { t } = this.props
        var antallTeiger = this.state.continuationToken ? `${this.state.teiger.length}/${this.props.antall}` : this.props.antall        
        return (
            <li>
                <div className="section-header" onClick={this.toggleTeiger}>
                    { !this.state.isLoading &&
                        <div className="icon-image"><img src={TeigIcon} /></div>
                    }
                    {
                        this.state.isLoading &&
                        <span className="icon"><i className="fa fa-fw fa-spinner fa-spin"></i></span>
                    }
                    <span className="title">{t('teiger')} ({antallTeiger})</span>
                    <div className="icon-image right"><img className="collapse" src={this.state.isOpened ? CollapseIcon : ExpandIcon} /></div>
                </div>
                <div className={this.state.isOpened && this.state.teiger.length > 0 ? "" : "collapsed"}>
                    <ul>
                        { this.state.teiger.map((t, index) => {return (<Teig key={t.teigId} teig={t} antall={this.props.antall} isLast={index==this.state.teiger.length-1} onEvent={this.props.onEvent} />)}) }
                        { this.state.continuationToken &&
                        <li key="HentFlere">
                            <div className="section-header subsection button" onClick={this.getTeiger}>
                                <span>{t('hent.teiger')}</span>
                            </div>
                        </li>
                        }
                    </ul>
                </div>
            </li>
        )
    }
}

export default withTranslation('common')(TeigList)